import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateDefaultSuggestions = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_DEFAULT_SUGGESTIONS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/domain-and-designation`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_DEFAULT_SUGGESTIONS_DONE',
              payload: {
                promptId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_DEFAULT_SUGGESTIONS_FAILED',
              payload: `Failed to update default suggestions`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_DEFAULT_SUGGESTIONS_FAILED',
            payload: `Failed to update default suggestions`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_DEFAULT_SUGGESTIONS_FAILED',
        payload: `Failed to update default suggestions`,
      });
    }
  };
};

export default updateDefaultSuggestions;
